import React, { useEffect, useState } from 'react';
import Summary from '../components/Summary';
import Select from 'react-select';
import WeeklyTable from '../components/Tables/Weekly/WeeklyTable';
import ToggleTable from '../components/Tables/Weekly/ToggleTable';
import WeeklyDatePicker from '../../payments/paymentsComponents/WeeklyDatePicker';
import {DownArrow, ToggleIcon} from '../components/helpers/svgHelper';

function Weekly({
  selectStyles,
  data,
  setData,
  handleChange,
  comparisonOptions,
  fetchCompanies,
  week,
  setWeek,
  selectedOption,
  consolidatedTotals,
  loading,
  selectedComparison
}) {
  const [tabView, setTabView] = useState(true);
  const [dropdown, setDropdown] = useState(false);

  // useEffect(() => {
  //     fetchCompanies();
  // }
  // , [selectedComparison]);

  
  const resetFilters = () => {
    setData([]);
  };  

  return (
    <div className="bg-transparent pt-2 pb-4 space-y-4">

      {loading && (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-50 flex flex-col items-center justify-center">
          <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
        </div>
      )}

      <div className="flex flex-row justify-between">
        <div className="flex flex-row w-9/12 space-x-2">
          <div className="relative inline-block text-left">
            <div>
              <button
                type="button"
                style={{ width: '150px' }}
                onClick={() => setDropdown(!dropdown)}
                className="inline-flex w-full justify-between gap-x-1.5 border-gray-400 border rounded-md bg-white text-gray-400 px-3 py-2 text-xxs font-thin shadow-sm"
              >
                {week.from} - {week.to}
                <DownArrow />
              </button>
            </div>
            {dropdown && <WeeklyDatePicker setWeek={setWeek} week={week} dropdown={dropdown} setDropdown={setDropdown} />}
          </div>

          {tabView && 
            ( 
              <Select
                value={selectedComparison}
                onChange={(option) => handleChange(option)}
                options={comparisonOptions}
                placeholder="Comparison Period"
                styles={selectStyles}
              />
            )
          }

          <div className="flex space-x-2" style={{ height: '40px'}}>
            <button
            disabled={selectedComparison === null}
            onClick={fetchCompanies}
            className={selectedComparison === null ? "bg-gray-400 text-gray-600 cursor-not-allowed font-normal text-sm py-1 px-4 rounded-lg" : "bg-purple-600 text-white font-normal text-sm py-1 px-4 rounded-lg"}
            >
              Apply Filters
            </button>

            <button
             onClick={resetFilters}
             className="border border-gray-300 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
            >
              Reset Filters
            </button>
          </div>
        </div>

        <div className="flex flex-row">
          <button
            disabled={data.length === 0}
            onClick={() => setTabView(!tabView)}
            className={data.length === 0 ? 
                    "w-8 h-8 bg-gray-400 cursor-not-allowed rounded-md shadow-xl flex items-center justify-center transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75" 
                    : "w-8 h-8 bg-purple-600 hover:bg-purple-700 rounded-md shadow-xl flex items-center justify-center transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75"}
          >
            <ToggleIcon />
          </button>
        </div>
      </div>

      {data.length > 0 && (
        <>
          <div className="w-full flex mt-2">
            <Summary title="Consolidated Totals" breakdown={consolidatedTotals} />
          </div>

          {tabView ? (
            <div
              className="overflow-y-auto px-2 scrollbar"
              style={{ maxHeight: '800px' }}>
              <WeeklyTable data={data} selectedComparison={selectedComparison} />
            </div>
          ) : (
            <div
              className="overflow-y-auto px-2 scrollbar"
              style={{ maxHeight: '800px' }}>
              <ToggleTable
                data={data}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Weekly;
